import { VendorActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { VendorFormData } from 'src/screens/General/screens/Vendors/components/VendorForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetVendorsAction {
    type: typeof VendorActions.FETCH_VENDORS;
    payload: QueryParams;
}

export function getVendors(params: QueryParams): GetVendorsAction {
    return {
        type: VendorActions.FETCH_VENDORS,
        payload: params,
    };
}

export interface GetVendorsSmallAction {
    type: typeof VendorActions.FETCH_VENDORS_SIMPLY;
    payload: QueryParams;
}

export function getVendorsSmall(params: QueryParams): GetVendorsSmallAction {
    return {
        type: VendorActions.FETCH_VENDORS_SIMPLY,
        payload: params,
    };
}

export interface GetVendorAction {
    type: typeof VendorActions.FETCH_VENDOR;
    payload: {
        id: string | number;
    };
}

export function getVendor(id: string | number): GetVendorAction {
    return {
        type: VendorActions.FETCH_VENDOR,
        payload: { id },
    };
}

export interface DeleteVendorAction {
    type: typeof VendorActions.DELETE_VENDOR;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteVendor(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteVendorAction {
    return {
        type: VendorActions.DELETE_VENDOR,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistVendorAction {
    type: typeof VendorActions.PERSIST_VENDOR;
    payload: {
        data: VendorFormData;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function persistVendor(data: VendorFormData, files: any, callbacks: SagaPromise<any>): PersistVendorAction {
    return {
        type: VendorActions.PERSIST_VENDOR,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export const asyncPersistVendor = (data: VendorFormData, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistVendor(data, files, { resolve, reject }));
    });
};

export const asyncCreateFilesVendor = (id: number | string, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(createFilesVendor(id, files, { resolve, reject }));
    });
};

export interface CreateFilesVendorAction {
    type: typeof VendorActions.CREATE_FILES_VENDOR;
    payload: {
        id: number | string;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function createFilesVendor(
    id: number | string,
    files: any,
    callbacks: SagaPromise<any>,
): CreateFilesVendorAction {
    return {
        type: VendorActions.CREATE_FILES_VENDOR,
        payload: {
            id,
            files,
            callbacks,
        },
    };
}

export interface GetFilesAction {
    type: typeof VendorActions.FETCH_FILES_VENDOR;
    payload: {
        id: string | number;
    };
}

export function getFiles(id: string | number): GetFilesAction {
    return {
        type: VendorActions.FETCH_FILES_VENDOR,
        payload: { id },
    };
}

export interface DeleteFileVendorAction {
    type: typeof VendorActions.DELETE_FILE_VENDOR;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileVendor(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileVendorAction {
    return {
        type: VendorActions.DELETE_FILE_VENDOR,
        payload: { id, onSuccess, onError },
    };
}

export type Actions = GetVendorsAction | GetVendorAction | DeleteVendorAction | PersistVendorAction;
